import { memo } from "react";

import MuiRadio from "@mui/material/Radio";
import { styled, Theme } from "@mui/material/styles";

import { getTransitions } from "../css";
import { InternalClasses } from "../helpers";

export type RadioBaseClasses =
  | "disabled"
  | "error"
  | "circleContainer"
  | "circleContainerForm"
  | "smallCircleContainer"
  | "circle"
  | "root"
  | "small";

export const searchSx = (theme: Theme) => ({
  marginBottom: theme.spacing(1),
});
const PREFIX = "ZeffyRadio";

export const zeffyRadioClasses: InternalClasses<typeof PREFIX, RadioBaseClasses> = {
  circleContainer: `${PREFIX}-circleContainer`,
  circleContainerForm: `${PREFIX}-circleContainerForm`,
  smallCircleContainer: `${PREFIX}-smallCircleContainer`,
  circle: `${PREFIX}-circle`,
  error: `${PREFIX}-error`,
  disabled: `${PREFIX}-disabled`,
  root: `${PREFIX}-root`,
  small: `${PREFIX}-small`,
};

export const StyledRadio = memo(
  styled(MuiRadio)(({ theme }: { theme: Theme }) => ({
    [`& .${zeffyRadioClasses.circleContainer}`]: {
      border: `1px solid ${theme.palette.border.neutral.intense}`,
      borderRadius: "50%",
      height: 20,
      padding: theme.spacing(0.5),
      width: 20,
    },

    [`& .${zeffyRadioClasses.circleContainerForm}`]: {
      borderColor: theme.palette.border.form.intense,
    },

    [`& .${zeffyRadioClasses.smallCircleContainer}`]: {
      padding: theme.legacySpacing(0.5) - 1,
    },

    [`& .${zeffyRadioClasses.circle}`]: {
      backgroundColor: theme.palette.surface.brand.intense,
      borderRadius: "50%",
      height: "100%",
    },

    [`& .${zeffyRadioClasses.error}`]: {
      borderColor: theme.palette.border.danger.intense,
    },

    [`&.${zeffyRadioClasses.root}`]: {
      height: 20,
      width: 20,
      padding: 0,
      ...getTransitions(),
      "&:hover": {
        backgroundColor: "unset",
        [`& .${zeffyRadioClasses.circleContainer}`]: {
          borderColor: theme.palette.border.brand.intense,
        },
      },
      "&:focus, &:focus-visible, &:focus-within": {
        [`& .${zeffyRadioClasses.circleContainer}`]: {
          borderColor: theme.palette.border.brand.intense,
          outline: `2px solid ${theme.palette.border.brand.quiet}`,
        },
      },
      [`&.${zeffyRadioClasses.disabled}`]: {
        opacity: 0.4,
      },
    },

    [`&.${zeffyRadioClasses.small}, .${zeffyRadioClasses.small}`]: {
      height: 16,
      width: 16,
    },
  }))
);
